import { ROUTES } from 'constants/routes'
import * as Pages from 'pages'
import type { RouteObject } from 'react-router-dom'

import { PrivateRoute } from './private'

const paymentGatewaysRoutes: RouteObject[] = [
  {
    path: ROUTES.PAYMENT_GATEWAYS.LIST,
    element: (
      <PrivateRoute>
        <Pages.PaymentGateways />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.PAYMENT_GATEWAYS.CREATE,
    element: (
      <PrivateRoute>
        <Pages.AddPaymentGateways />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.PAYMENT_GATEWAYS.EDIT(':id'),
    element: (
      <PrivateRoute>
        <Pages.EditPaymentGateways />
      </PrivateRoute>
    ),
  },
  {
    path: ROUTES.PAYMENT_GATEWAYS.VIEW(':id'),
    element: (
      <PrivateRoute>
        <Pages.ViewPaymentGateways />
      </PrivateRoute>
    ),
  },
]

export default paymentGatewaysRoutes
